<script setup lang="ts">
const documentId = inject("documentId") as any;
const documentChecklistStore = useDocumentChecklistStore(documentId);
const { isInitialized } = storeToRefs(documentChecklistStore);
</script>

<template>
  <div v-auto-animate class="h-full">
    <ChecklistSummary class="h-full" />
  </div>
</template>

<style scoped></style>
